import Cookies from 'js-cookie'
import { v4 as uuidv4 } from 'uuid'
import SHA256 from 'crypto-js/sha256'
import { clearTransactionListFilters } from 'utils/transactionListFilters'

const COOKIE_NAME = 'did'
const LS_KEY = 'device_token'
const LS_REFRESH_TOKEN = 'refresh_token'
const LS_EXPIRES_AT = 'token_expires_at'
const LS_REFRESH_EXPIRES_AT = 'token_refresh_expires_at'

const inhouseChat = (...args) =>
  typeof window !== 'undefined' && window.InhouseChat ? window.InhouseChat(...args) : undefined

export const getToken = () => Cookies.get('token')
export const isTokenExist = () => !!getToken()

// Widget In-house Chat TIDAK di-boot di sini: ditampilkan oleh layout Main setelah
// inits sukses & company-nya sesuai (lihat utils/inhouseChat.js).
export const setToken = (token) => {
  Cookies.set('token', token, { expires: 30 * 12 }) // 1 tahun
}

export const removeToken = () => {
  const wasLoggedIn = isTokenExist()
  // Logout (termasuk refresh token gagal): buang sesi chat user ini dari
  // perangkat dan hapus widget dari halaman.
  if (wasLoggedIn) {
    inhouseChat('shutdown')
  }
  Cookies.remove('token')
}

// export const setToken = (token) => {
//   Cookies.set('token', token, { expires: 30 * 12 }) // 1 tahun
// }

// export const removeToken = () => Cookies.remove('token')

/** JWT: Simpan refresh_token di localStorage (untuk JWT flow) */
export const setRefreshToken = (refreshToken) => {
  try {
    if (refreshToken) {
      localStorage.setItem(LS_REFRESH_TOKEN, refreshToken)
    } else {
      localStorage.removeItem(LS_REFRESH_TOKEN)
    }
  } catch (_) {
    // Safari private mode bisa throw
  }
}
export const getRefreshToken = () => {
  try {
    return localStorage.getItem(LS_REFRESH_TOKEN) || null
  } catch (_) {
    return null
  }
}

/** JWT: Simpan expires_at di localStorage */
export const setExpiresAt = (expiresAt) => {
  try {
    if (expiresAt) {
      localStorage.setItem(LS_EXPIRES_AT, expiresAt)
    } else {
      localStorage.removeItem(LS_EXPIRES_AT)
    }
  } catch (_) {
    // Safari private mode bisa throw
  }
}
export const getExpiresAt = () => {
  try {
    return localStorage.getItem(LS_EXPIRES_AT) || null
  } catch (_) {
    return null
  }
}

/** JWT: Simpan refresh_expires_at di localStorage */
export const setRefreshExpiresAt = (refreshExpiresAt) => {
  try {
    if (refreshExpiresAt) {
      localStorage.setItem(LS_REFRESH_EXPIRES_AT, refreshExpiresAt)
    } else {
      localStorage.removeItem(LS_REFRESH_EXPIRES_AT)
    }
  } catch (_) {
    // Safari private mode bisa throw
  }
}
export const getRefreshExpiresAt = () => {
  try {
    return localStorage.getItem(LS_REFRESH_EXPIRES_AT) || null
  } catch (_) {
    return null
  }
}

/** Hapus seluruh data autentikasi (access_token + refresh_token + expires_at) */
export const clearAuthTokens = () => {
  removeToken()
  setRefreshToken(null)
  setExpiresAt(null)
  setRefreshExpiresAt(null)
  // Sesi berakhir: filter terakhir daftar transaksi ikut direset agar tidak terbawa saat login ulang
  clearTransactionListFilters()
}

export const setSavedEmail = (email) => {
  Cookies.set('email', email, { expires: 30 * 12 }) // 1 tahun
}
export const getSavedEmail = () => Cookies.get('email')
export const isEmailSavedExist = () => !!getSavedEmail()
export const removeSavedEmail = () => Cookies.remove('email')

export function getOrCreateDeviceId() {
  // 1) Prefer cookie
  let did = Cookies.get(COOKIE_NAME)

  // 2) If no cookie, check localStorage
  if (!did) {
    try {
      did = localStorage.getItem(LS_KEY) || ''
    } catch (_) {
      // Safari private mode can throw, ignore
    }
  }

  // 3) Create new if none
  if (!did) {
    const raw = `${uuidv4()}${Date.now()}`
    const hash = SHA256(raw).toString()
    did = hash.substring(0, 32)
  }
  const host = window.location.hostname
  const cookieDomain = host.endsWith('.kledo.com') ? '.kledo.com' : undefined
  // 4) Persist to both cookie + LS
  Cookies.set(COOKIE_NAME, did, {
    secure: true,
    sameSite: 'lax',
    expires: 30 * 12, // 1 tahun
    path: '/',
    domain: cookieDomain,
  })
  try {
    localStorage.setItem(LS_KEY, did)
  } catch (_) {
    // Safari private mode can throw, ignore
  }

  return did
}
